import * as React from 'react'
import {connect} from "react-redux"
import {ApplicationState} from "../../store"
import {Button, Grid, Paper, List, ListItem, ListItemIcon, ListItemText, Checkbox, InputLabel, Divider} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save"
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab"
import {actionRoleFetch, actionRoleSave} from "../../store/roles/actions"
import {actionRoleFetchAll} from "../../store/roles"
import {RoleDescriptor} from "../../models/Role"
import {Utility} from "../../core/Utility"
import {actionActiveTabTitle} from "../../store/tabs/actions"
import {Tab} from "../Tab"
import {Validator} from "../../core/Validator"
import {AppCookies} from "../../core/Cookies"
import {t} from "../../core/localization"
import {permissions, documentPermissions} from "../../test/permissionsTest"
import {Permissions} from "../../core/auth/Permissions"
import PermissionContainer from "../../core/auth/PermissionContainer"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {EntityField} from "../../core/genericdocuments/EntityField"
import {FieldView} from "../components/FieldView"
import {roleFieldsDescriptor} from "./RoleFields"

export interface RoleTabProps extends BaseTabProps{
	tab: Tab
}

export interface RoleTabState extends BaseTabState{
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any,
	grantedPermissions: string[],
	unauthorizedPermissions: string[],
	checkedPermissions: string[],
	documentGrantedPermissions: string[],
	documentUnauthorizedPermissions: string[],
	documentCheckedPermissions: string[]
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active
	}
}

class RoleTab extends BaseTab<RoleTabProps, RoleTabState> {

	constructor(props: RoleTabProps) {
		super(props)
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: '',
		validation: { valid: true, fields: [] },
		checkedPermissions: [],
		grantedPermissions: (Utility.formatPermissionString(this.getItemFromTabState('permissions'))),
		unauthorizedPermissions: Utility.not(permissions.split(','), (Utility.formatString(this.getItemFromTabState('permissions'))).split(',')),
		documentCheckedPermissions: [],
		documentGrantedPermissions: (Utility.formatPermissionString(this.getItemFromTabState('documentPermissions'))),
		documentUnauthorizedPermissions: Utility.not(documentPermissions.split(','), (Utility.formatString(this.getItemFromTabState('documentPermissions'))).split(','))}
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: RoleTabProps) {
	}

	componentDidMount() {
		actionRoleFetchAll()
		if (this.props.item.id) actionRoleFetch(this.props.item)
		AppCookies.getAccessToken()
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderForm()}
				{this.renderFormControls()}
			</div>
		)
	}

	renderForm(): React.ReactNode {

		let descriptor: EntityFieldsDescriptor<any> = roleFieldsDescriptor

		return <form className='ev-form' noValidate autoComplete="on">
			<div className="create-form">
				{descriptor && descriptor.createFormFields.map(
					(entityField: EntityField<any>, index: number) => {
						const fieldName = entityField.name.toString()
						let value = Utility.formatString(this.getItemFromTabState(fieldName))
						return (
							<div style={{ marginBottom: "0px", padding: "0px" }}>
								{<FieldView value={value}
									autoFocus={index === 0} field={entityField} formState={null}
									setFormState={null}
									handleInputChange={(fieldName, value) => this.handleItemGenericInputChange(fieldName, value)}
									validationState={this.state.validation}
									lookupData={null}
								/>}
							</div>
						)
					}
				)}
			</div>
				<Grid container spacing={2} justify="center" alignItems="center" style={{marginTop:"10px"}}>
					<Grid item>
					<Paper style={{margin:"10px",width:"250px",height:"300px",overflow:"auto"}}>
						<InputLabel htmlFor="age-required" style={{margin:"10px",textAlign:"center"}}>{t.UnauthorizedPermissions}</InputLabel>
						<Divider />
						<List dense component="div" role="list">
							{this.state.unauthorizedPermissions.map((value: string) => {
							return (
								<ListItem key={value} role="listitem" button onClick={
									() => {
										const currentIndex = this.state.checkedPermissions.indexOf(value);
										const newChecked = [...this.state.checkedPermissions];
										if (currentIndex === -1) {
											newChecked.push(value);
										} else {
											newChecked.splice(currentIndex, 1);
										}
										this.setState({ ...this.state, checkedPermissions: newChecked})
										}
									}>
								<ListItemIcon>
									<Checkbox checked={this.state.checkedPermissions.indexOf(value) !== -1} tabIndex={-1} disableRipple/>
								</ListItemIcon>
								<ListItemText primary={value} />
								</ListItem>
								);
								})}
						</List>
					</Paper>
					</Grid>
					<Grid item>
						<Grid container direction="column" alignItems="center">
						<Button variant="outlined" size="small" onClick={
							async ()=>{
								const leftChecked: string[] = Utility.intersection(this.state.checkedPermissions, this.state.unauthorizedPermissions)
								const newUnauthorizedPermissions: string[] = Utility.not(this.state.unauthorizedPermissions, leftChecked)
								await	this.setState({unauthorizedPermissions:newUnauthorizedPermissions})
								let newGrantedPermissions: string[] = [...this.state.grantedPermissions].concat(leftChecked)
								await	this.setState({grantedPermissions:newGrantedPermissions})
								const newCheckedPermissions = Utility.not(this.state.checkedPermissions, leftChecked)
								await	this.setState({checkedPermissions:newCheckedPermissions})
								await this.handleItemPermissionChange(this.state.grantedPermissions.join(), 'permissions')
								}
						}
						disabled={Utility.intersection(this.state.checkedPermissions, this.state.unauthorizedPermissions).length === 0} aria-label="move selected right">
							&gt;</Button>
						<Button variant="outlined" size="small" onClick={
							async ()=>{
								const rightChecked: string[] = Utility.intersection(this.state.checkedPermissions, this.state.grantedPermissions)
								const newGrantedPermissions: string[] = Utility.not(this.state.grantedPermissions, rightChecked)
								await this.setState({grantedPermissions:newGrantedPermissions})
								let newUnauthorizedPermissions: string[] = [...this.state.unauthorizedPermissions].concat(rightChecked)
								await this.setState({unauthorizedPermissions:newUnauthorizedPermissions})
								const newCheckedPermissions = Utility.not(this.state.checkedPermissions, rightChecked)
								await this.setState({checkedPermissions:newCheckedPermissions})
								await this.handleItemPermissionChange(this.state.grantedPermissions.join(), 'permissions')
								}
						}
						disabled={Utility.intersection(this.state.checkedPermissions, this.state.grantedPermissions).length === 0}  aria-label="move selected left">
							&lt;</Button>
						</Grid>
					</Grid>
					<Grid item>
						<Paper style={{margin:"10px",width:"250px",height:"300px",overflow:"auto"}}>
							<InputLabel htmlFor="age-required" style={{margin:"10px",textAlign:"center"}}>{t.GrantedPermissions}</InputLabel>
							<Divider />
							<List dense component="div" role="list">
							{this.state.grantedPermissions.map((value: string) => {
							return (
								<ListItem key={value} role="listitem" button onClick={
									() => {
										const currentIndex = this.state.checkedPermissions.indexOf(value);
										const newChecked = [...this.state.checkedPermissions];
										if (currentIndex === -1) {
											newChecked.push(value);
										} else {
											newChecked.splice(currentIndex, 1);
										}
										this.setState({ ...this.state, checkedPermissions: newChecked})
										}
									}>
								<ListItemIcon>
									<Checkbox checked={this.state.checkedPermissions.indexOf(value) !== -1} tabIndex={-1} disableRipple/>
								</ListItemIcon>
								<ListItemText primary={value} />
								</ListItem>
								)
								})}
							</List>
						</Paper>
					</Grid>
				</Grid>
				<Divider style={{margin:"15px"}}/>
		</form>
	}

	renderFormControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse', marginTop: '10px'}}>
				<PermissionContainer hasPermission={Permissions.ROLES_EDIT}>
					<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary"><SaveIcon />Save</Button>
				</PermissionContainer>
			</div>
	}

	onSaveClick () {
		let itemToSave = this.getItemFromTabState()

		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, RoleDescriptor)

		if (validation.valid) {
			actionRoleSave(itemToSave)
			actionActiveTabTitle(t.Role + ': ' + this.getItemFromTabState('name'))
		}

		this.setState({ ...this.state, validation});
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

}

export default connect(mapStateToProps)(RoleTab)
